var map = {
	"./Aquafist.webp": [
		43358,
		3358
	],
	"./ArchieSparks.webp": [
		61981,
		1981
	],
	"./BigTszu.webp": [
		20634,
		634
	],
	"./BoulderBelle.webp": [
		27001,
		7001
	],
	"./ChillBill.webp": [
		58428,
		8428
	],
	"./Ember.webp": [
		51668,
		1668
	],
	"./HammerTime.webp": [
		56256,
		6256
	],
	"./HotRocks.webp": [
		2830,
		2830
	],
	"./Kimpale.webp": [
		89441,
		9441
	],
	"./LightningTiger.webp": [
		97168,
		7168
	],
	"./MinionCrew.webp": [
		81809,
		1809
	],
	"./RockDude.webp": [
		63602,
		3602
	],
	"./Sheara.webp": [
		34635,
		4635
	],
	"./ShieldMaiden.webp": [
		13329,
		3329
	],
	"./Skadi.webp": [
		13961,
		3961
	],
	"./SparkCrows.webp": [
		48189,
		8189
	],
	"./Spearnado.webp": [
		78639,
		8639
	],
	"./Sunbird.webp": [
		87242,
		7242
	],
	"./Tidal.webp": [
		451,
		451
	],
	"./Torcher.webp": [
		27694,
		7694
	],
	"./WaterOwl.webp": [
		6143,
		6143
	],
	"./Whirlwind.webp": [
		9409,
		9409
	],
	"./Windja.webp": [
		30667,
		667
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83826;
module.exports = webpackAsyncContext;